export const CLINIC_TYPES = {
    GET_IMPLEMENTATION_CHECKLIST:"GET_IMPLEMENTATION_CHECKLIST",
    SAVE_IMPLEMENTATION_CHECKLIST:"SAVE_IMPLEMENTATION_CHECKLIST",
    UPDATE_IMPLEMENTATION_CHECKLIST:"UPDATE_IMPLEMENTATION_CHECKLIST",
    GET_CLINIC_DETAILS:"GET_CLINIC_DETAILS",
    SAVE_CLINIC_DETAILS:"SAVE_CLINIC_DETAILS",
    GET_SERVICE_AUDIT_LOG: "GET_SERVICE_AUDIT_LOG",
    SAVE_SERVICE_AUDIT_LOG: "SAVE_SERVICE_AUDIT_LOG",
    IS_DEFAULT_GOAL_ASSIGNED:"IS_DEFAULT_GOAL_ASSIGNED"

   }
   